<header [class.narrow]="shouldUseNarrowMainContainer()" [ngClass]="isDesktopImageVisible().toString()"
        class="relative h-12 w-full bg-white shadow lg:h-16"
        id="header">
  <nav
    [ngClass]="getContainerClasses()"
    class="mx-auto flex items-center justify-between whitespace-nowrap  lg:h-16"
  >
    <div class="flex items-center">
      <a [routerLink]="['/']" class="mr-5 shrink-0 3xl:mr-16">
        <img
          [attr.fetchpriority]="'high'"
          [priority]="true"
          alt="Vården.se logotyp"
          height="24"
          ngSrc="{{ s3AssetUrl }}varden-logo-nocross.svg"
          width="139"
        >
      </a>
      @if (isDesktopImageVisible()) {
        <img
          alt="Hjärta"
          class="hidden 3xl:block"
          height="64"
          ngSrc="{{ s3AssetUrl }}heart.webp"
          width="79"
        >
        <img
          alt="Stetoskop"
          class="hidden 3xl:block"
          height="64"
          ngSrc="{{ s3AssetUrl }}stethoscope.webp"
          width="105"
        >
      }


      <picture class="relative top-[3px]">
        <source
          height="15"
          media="(max-width: 991px)"
          srcset="{{s3AssetUrl}}sok-jamfor-boka-mobile.webp"
          type="image/webp"
          width="123"
        >

        <img
          alt="Sök, jämför och boka vård"
          height="15"
          ngSrc="{{ s3AssetUrl }}sok-jamfor-boka-desktop.webp"
          width="311"
        >
      </picture>
      @if (isDesktopImageVisible()) {
        <img
          alt="Handshake"
          class="hidden 3xl:block"
          height="64"
          ngSrc="{{ s3AssetUrl }}handshake.webp"
          width="74"
        >
        <img
          alt="Tand"
          class="hidden 3xl:block"
          height="64"
          ngSrc="{{ s3AssetUrl }}tooth.webp"
          width="80"
        >
      }
    </div>
    <div class="flex items-center">
      <div
        class="hidden h-full items-center justify-end gap-2 font-medium md:flex"
      >
        <a
          [indexedLink]="['/']"
          [routerLink]="['/', 'minasidor']"
          [targetParams]="{}"
          [targetUrl]="['/', 'minasidor']"
          appIndexedLink
          aria-label="Mina sidor"
          class="block py-2 px-4 hover:rounded-full hover:bg-grey-10 lg:py-3 cursor-pointer"
          rel="nofollow"
          title="Mina sidor"
        >Mina sidor
        </a>
        <a
          aria-label="Anslut mottagning"
          class="block py-2 px-4 hover:rounded-full hover:bg-grey-10 lg:py-3"
          href="https://vardgivare.varden.se/"
          title="Anslut mottagning"
        >Anslut mottagning</a
        >
        <a aria-label="Chatt (ny!)"
           class="flex gap-2 items-center py-2 px-4 hover:rounded-full hover:bg-grey-10 lg:py-3"
           href="https://chatt.varden.se/"
           title="Chatt"
        >
          <app-ui-icon class="mb-1" color="var(--duck-blue-2)" name="bot" size="md"></app-ui-icon>
          <span>Chatt <sup class="text-apricot-5 font-black">ny!</sup></span>
        </a>
      </div>

      <button
        (click)="menuToggle()"
        aria-label="Meny"
        class="icon-button ml-4"
        type="button"
      >
        <app-ui-icon color="var(--grey-1)" name="menu"></app-ui-icon>
      </button>
    </div>
  </nav>
</header>
